import html2canvas from 'html2canvas';

/**
 * Converts a DOM element to PNG image and returns the generated blob URL.
 * @param {HTMLElement} domElement - The DOM element to convert to an image.
 * @param {Array<string>} ignoreClasses - List of class names to ignore.
 * @param {Array<string>} ignoreTags - List of tag names to ignore.
 * @param {number} scale - The scale factor for the canvas (default is 1).
 * @returns {Promise<string>} - A promise that resolves to the PNG blob URL.
 */
export async function generateDashboardReport(
    domElement,
    ignoreClasses = [],
    ignoreTags = [],
    scale = 1
) {
    if (!domElement) {
        throw new Error('Invalid DOM element provided.');
    }

    // Generate a canvas from the DOM element
    const canvas = await html2canvas(domElement, {
        scale, // Use the provided scale for better quality
        useCORS: true,
        ignoreElements: (node) => {
            const tagName = node.tagName?.toLowerCase();
            return (
                ignoreClasses.some((className) => node.classList?.contains(className)) ||
                ignoreTags.includes(tagName)
            );
        },
    });

    return canvas.toDataURL('image/png');
}
